// global place for storing app routing history object
export default {
    history: undefined,
};
